import { API_ORIGIN } from "../../../api/http";

export function toAbsoluteMediaUrl(url) {
  if (!url) return "";

  if (url.startsWith("http://") || url.startsWith("https://")) return url;

  if (url.startsWith("/")) {
    return API_ORIGIN ? `${API_ORIGIN}${url}` : url;
  }

  return API_ORIGIN ? `${API_ORIGIN}/${url}` : url;
}

export function getSortedMediaByType(property, mediaType) {
  const all = property?.media || property?.PropertyMedia || [];
  const filtered =
    mediaType !== null && mediaType !== undefined
      ? all.filter((media) => media.media_type === mediaType)
      : all;

  return [...filtered].sort(
    (a, b) =>
      new Date(b.created_at || b.createdAt || 0) -
      new Date(a.created_at || a.createdAt || 0),
  );
}
